import { Toggletip, ToggletipButton, ToggletipContent } from '@carbon/react';
import { Information } from '@carbon/react/icons';
import type { FilterFieldConfig } from '../types';
import style from './filter-modal.module.scss';

/**
 * A filter's label, with its explanation in a toggletip beside it when the
 * filter has one. It sits beside its control's own label rather than inside
 * it, so the control is named by its label alone and the toggletip button
 * never forwards a click to the control.
 * @param {object} props The label.
 * @param {FilterFieldConfig} props.field The filter.
 * @return {JSX.Element} The label.
 */
export function FieldLabel({
  field,
}: {
  field: Pick<FilterFieldConfig, 'label' | 'helperText'>;
}) {
  return (
    <span className={style.fieldLabel}>
      <span className="bx--label">{field.label}</span>
      {field.helperText && (
        <Toggletip align="top" autoAlign>
          <ToggletipButton label={`About ${field.label}`}>
            <Information />
          </ToggletipButton>
          <ToggletipContent>
            <p>{field.helperText}</p>
          </ToggletipContent>
        </Toggletip>
      )}
    </span>
  );
}
